module.exports = __webpack_public_path__ + "img/rocket.1b1eacae.svg";